export class ListAllErrorEffect {
  public static readonly type = '[Project/Storage/List] ListAllErrorEffect';
  constructor(public readonly error: Error) {}
}
